export default __webpack_public_path__ + "static/media/1788.d7d4ec97.png";